import { useState, useRef, useEffect } from "react";
import { FiEdit3 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../state/store";
import { updateCaselet } from "../pages/caselet/caseletSlice";
import { handleUpdateCaseletClick } from "../pages/thoughts/chat/ChatCardButton";
import { newChallenge } from "../pages/caselet/challenges/DecisionPoint";
import { successToast } from "../utils/common";

interface CardProps {
    title?: string;
    content?: string;
    decisionPointTitle?: string;
}

const CardVideo = ({ title, content: initialContent, decisionPointTitle }: CardProps) => {
    const [isEditing, setIsEditing] = useState(false);
    const caseletData = useSelector((state: RootState) => state.caselet);
    const dispatch = useDispatch<AppDispatch>();
    const [content, setContent] = useState("");
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const contentString = Array.isArray(initialContent)
        ? initialContent.join("")
        : typeof initialContent === "object"
        ? JSON.stringify(initialContent)
        : initialContent;
    const contentIsEmpty = !initialContent || (Array.isArray(initialContent) && initialContent.length === 0);
   
    useEffect(() => {
        if (isEditing && textareaRef.current) {
            textareaRef.current.style.height = "auto";
            textareaRef.current.style.minHeight = `${textareaRef.current.scrollHeight}px`;
            textareaRef.current.focus();
        }
    }, [isEditing]);

    useEffect(() => {
        if (isEditing) {
            setIsEditing(false);
        }
    }, [decisionPointTitle]);

    const handleEdit = () => {
        setContent(""); // Clear content when entering editing mode
        setIsEditing(true);
    };

    const handleContentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setContent(event.target.value);
    };

    const handleSave = async (event: React.MouseEvent) => {
        event.stopPropagation();
        if (typeof content === "string") {
            if (decisionPointTitle) {
                newChallenge.title = decisionPointTitle;
            }
            newChallenge.challenge = content;
        }

        let updatedCaselet = JSON.parse(JSON.stringify(caseletData));

        for (var i = 0; i < updatedCaselet.challenges.length; i++) {
            if (updatedCaselet.challenges[i].title === decisionPointTitle) {
                updatedCaselet.challenges.splice(i, 1, newChallenge);
            }
        }

        const result = await handleUpdateCaseletClick(updatedCaselet);
        dispatch(updateCaselet(result.caselet));

        setIsEditing(false);
        successToast("Saved Successfully");
    };

    const handleCancel = (event: React.MouseEvent) => {
        event.stopPropagation();
        setContent(""); // Clear content when canceling edit
        setIsEditing(false);
    };

    return (
        <div className="card-component bg-white mt-4 text-black p-4 rounded-lg transition-transform w-full sm:w-8/10 relative shadow-lg">
            <h2 className="font-title">{title}</h2>
            <div className="card-content min-h-fit hyphens-auto" style={{ maxWidth: "99%", overflowWrap: "break-word" }}>
                {isEditing ? (
                    <textarea className="w-11/12 p-2" value={content} onChange={handleContentChange} style={{ resize: "none" }} ref={textareaRef} />
                ) : (
                    contentString
                )}
            </div>
            <div>
                {isEditing ? (
                    <>
                        <div className="font-hover-save font-top-position">{content?.length ? <button onClick={handleSave}>Save</button> : ""}</div>
                        <div className="font-hover-cancel font-bottom-position">
                            <button onClick={handleCancel}>Cancel</button>
                        </div>
                    </>
                ) : (
                    <div className="font-hover-edit font-top-position flex">
                        {contentIsEmpty ? <FiEdit3 className="mr-3 cursor-pointer" onClick={handleEdit} /> : ""}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CardVideo;
